export default "__VITE_ASSET__k69Ssy7H__"